import React, { useEffect, useState } from "react";
import { getFilteredSessions, getChapterTopic } from "../../lib/LiveclassContent";
import { getSubjectsByclassId } from "../../lib/ClassApi";
//import { getSubjectsByClass } from "../../lib/Subscription";
import { useNavigate, useLocation } from "react-router-dom";
import { getContentsByTopicID } from "../../lib/LiveclassContent";
//import { getStudentDetails } from "../../lib/AuthApi";
import { getTestByTestId } from "../../lib/McqApi";
//import { readSmartClassXML } from "../../lib/readSmartClassXML";
//import PlayerPage from "../../pages/player/PlayerPage"
import { useAuth } from "../../context/AuthProvider";

export default function PastSessions() {
  const navigate = useNavigate();
  const location = useLocation();
  const [filters, setFilters] = useState({
    classId: "",
    subject: "",
    chapter: "",
    topic: "",
    date: "",
  });
  //const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);
  const [topicContents, setTopicContents] = useState([]);
  const [contentLoading, setContentLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [classList, setClassList] = useState([]);
  const [subjectsList, setSubjectsList] = useState([]);
  const [chapterList, setChapterList] = useState([]);

  const { user } = useAuth();

  const role = user?.role?.toLowerCase();

  const isStudent = role === "student";

  const isTeacher = role === "teacher";

  //const isAdmin = role === "admin";

  // ================= GET CLASS =================
  // useEffect(() => {
  //   const fetchClasses = async () => {
  //     try {
  //       const res = await getStudentDetails();

  //       const student = res?.[0];

  //       if (student?.UserClasses) {
  //         setClassList(student.UserClasses);
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   fetchClasses();
  // }, []);
  // ================= GET CLASS FROM LOCAL STORAGE =================
  useEffect(() => {

    const storedUser = localStorage.getItem("user");

    if (storedUser) {

      const userData = JSON.parse(storedUser);

      // if (userData?.UserClasses) {

      //   setClassList(userData.UserClasses);

      //   // AUTO SELECT FIRST CLASS
      //   if (userData.UserClasses.length > 0) {

      //     setFilters((prev) => ({
      //       ...prev,
      //       classId: userData.UserClasses[0].ClassId,
      //     }));

      //   }
      // }

      if (isStudent && userData?.UserClasses) {

        setClassList(userData.UserClasses);

        if (userData.UserClasses.length > 0) {

          setFilters((prev) => ({
            ...prev,
            classId: userData.UserClasses[0].ClassId,
          }));

        }
      }

      // ================= TEACHER =================

      if (isTeacher && userData?.UserClasses) {

        console.log("TEACHER CLASSES:", userData.UserClasses);

        setClassList(userData.UserClasses);

        if (userData.UserClasses.length > 0) {

          setFilters((prev) => ({
            ...prev,
            classId: userData.UserClasses[0].ClassId,
          }));

        }
      }
    }

  }, []);
  useEffect(() => {

    if (location.state?.returnState) {

      const savedState = location.state.returnState;

      setSelectedSession(savedState.selectedSession || null);

      setTopicContents(savedState.topicContents || []);

      setFilters(savedState.filters || {
        classId: "",
        subject: "",
        chapter: "",
        topic: "",
        date: "",
      });

      setSessions(savedState.sessions || []);

    }

  }, [location.state]);
  // ================= GET SUBJECT =================
  useEffect(() => {
    if (filters.classId) {
      fetchSubjects(filters.classId);
    } else {
      setSubjectsList([]);
    }
  }, [filters.classId]);

  const fetchSubjects = async (classId) => {
    try {
      const res = await getSubjectsByclassId(classId);

      if (res.success) {
        setSubjectsList(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ================= GET CHAPTER/TOPIC =================
  useEffect(() => {
    if (filters.classId && filters.subject) {
      fetchChapterTopic(filters.classId, filters.subject);
    } else {
      setChapterList([]);
    }
  }, [filters.classId, filters.subject]);

  const fetchChapterTopic = async (classId, subjectId) => {
    try {
      const res = await getChapterTopic({
        classId,
        subjectId,
      });

      if (res.success) {
        setChapterList(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ================= FETCH SESSIONS =================
  const fetchSessions = async () => {
    setLoading(true);

    try {
      const data = localStorage.getItem("user");
      const user = data ? JSON.parse(data) : {};

      const res = await getFilteredSessions(
        filters,
        user?.uuid || user?.id
      );

      const formatted = (res?.liveClass || []).map((item, index) => ({
        id: item.id || index + 1,
        sessionTitle: `Session ${index + 1}`,
        startTime: item.starttime || "--",
        endTime: item.endtime || "--",
        subject: item.subjectName,
        chapter: item.chapterName,
        topic: item.topicName,
        teacher: item.teacherName,
        class: item.id,
        topicId: item.topicId,
        teacher: item.teacherName || item.teacherEmail || "-",
        recordedVideoUrl: item.recordedVideoUrl,
        notesUrl: item.notesUrl,
        testUrl: item.testUrl,
      }));

      setSessions(formatted);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  //=============handle view details==================
  const handleViewDetails = async (session) => {
    try {

      setSelectedSession(session);
      setContentLoading(true);

      const res = await getContentsByTopicID(session.topicId);

      console.log("FULL RESPONSE:", res);

      // if res is array
      console.log("FIRST PLAY URL:", res?.[0]?.playUrl);

      // print all play urls
      res?.forEach((item, index) => {
        console.log(`Play URL ${index}:`, item.playUrl);
      });

      setTopicContents(res || []);
      // const liveOnly = (res || []).filter(
      //   item => item.islive === true
      // );

      // setTopicContents(liveOnly);

    } catch (err) {

      console.error(err);

    } finally {

      setContentLoading(false);

    }
  };
  // ================= FILTER CHANGE =================
  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };


  //===============Group Content type================
  const groupedContents = topicContents.reduce((acc, item) => {
    console.log("=====Content url returned by api======", topicContents.playUrl);
    const type = item.mediatype?.toLowerCase();

    if (!acc[type]) {
      acc[type] = [];
    }

    acc[type].push(item);

    return acc;

  }, {});




  return (
    <div className="p-4">

      {/* ================= FILTER SECTION ================= */}
      {(isStudent || isTeacher) && (
        <div className="bg-white shadow rounded-xl p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

            {/* CLASS */}
            <select
              value={filters.classId}
              onChange={(e) => handleChange("classId", e.target.value)}
              className="border rounded-lg px-3 py-2"
            >
              <option value="">Select Class</option>

              {/* {classList.map((cls) => (
                <option key={cls.ClassId} value={cls.ClassId}>
                  {cls.classname}
                </option>
              ))} */}

              {classList.map((cls, index) => (
                <option
                  key={cls.ClassId || cls.classId || index}
                  value={cls.ClassId || cls.classId}
                >
                  {cls.classname || cls.className}
                </option>
              ))}
            </select>

            {/* SUBJECT */}
            <select
              value={filters.subject}
              onChange={(e) => handleChange("subject", e.target.value)}
              disabled={!filters.classId}
              className="border rounded-lg px-3 py-2"
            >
              <option value="">All Subject</option>

              {subjectsList.map((sub) => (
                <option key={sub.subjectId} value={sub.subjectId}>
                  {sub.subjectName}
                </option>
              ))}
            </select>

            {/* CHAPTER */}
            <select
              value={filters.chapter}
              onChange={(e) => handleChange("chapter", e.target.value)}
              disabled={!filters.subject}
              className="border rounded-lg px-3 py-2"
            >
              <option value="">All Chapter</option>

              {chapterList.map((ch) => (
                <option key={ch.chapterId} value={ch.chapterId}>
                  {ch.chapterName}
                </option>
              ))}
            </select>

            {/* TOPIC */}
            <select
              value={filters.topic}
              onChange={(e) => handleChange("topic", e.target.value)}
              disabled={!filters.chapter}
              className="border rounded-lg px-3 py-2"
            >
              <option value="">All Topic</option>

              {chapterList
                .find((ch) => ch.chapterId == filters.chapter)
                ?.topics?.map((t) => (
                  <option key={t.topicid} value={t.topicid}>
                    {t.topicname}
                  </option>
                ))}
            </select>

            {/* DATE */}
            <input
              type="date"
              value={filters.date}
              onChange={(e) => handleChange("date", e.target.value)}
              className="border rounded-lg px-3 py-2"
            />

            {/* BUTTON */}
            <button
              onClick={fetchSessions}
              className="bg-primary hover:bg-purple-700 text-white rounded-lg px-4 py-2"
            >
              Apply Filter
            </button>

          </div>
        </div>
      )}

      {/* ================= LOADING ================= */}
      {loading && (
        <div className="text-center mt-10">
          Loading...
        </div>
      )}

      {/* ================= NO DATA ================= */}
      {!loading && sessions.length === 0 && (
        <div className="text-center mt-10 text-gray-500">
          No Past Sessions Found
        </div>
      )}

      {/* ================= SESSION CARDS =================   {!loading && sessions.length > 0 && (*/}
      {/* SESSION CARDS */}
      {!loading &&
        sessions.length > 0 &&
        !selectedSession && (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

            {sessions.map((session) => (
              <div
                key={session.id}
                className="bg-white rounded-xl shadow border overflow-hidden"
              >

                {/* HEADER */}
                <div className="bg-gray-200 px-4 py-3 flex justify-between items-center">
                  <h2 className="font-semibold text-lg">
                    {session.sessionTitle}
                  </h2>

                  <span className="text-sm font-medium">
                    {session.startTime}
                  </span>
                </div>

                {/* BODY */}
                <div className="p-4 space-y-4">

                  {/* <div>
                  <span className="font-semibold">Time : </span>
                  {session.startTime} - {session.endTime}
                </div> */}

                  <div>
                    <span className="font-semibold">Subject : </span>
                    {session.subject}
                  </div>

                  <div>
                    <span className="font-semibold">Chapter : </span>
                    {session.chapter}
                  </div>

                  <div>
                    <span className="font-semibold">Topic : </span>
                    {session.topic}
                  </div>

                  <div>
                    <span className="font-semibold">Teacher : </span>
                    {session.teacher}
                  </div>

                  {/* RECORDING BUTTON */}
                  <button
                    disabled={!session.recordedVideoUrl}
                    onClick={() =>
                      navigate("/player", {
                        state: {
                          url: `http://localhost:5050${session.recordedVideoUrl}`,
                        },
                      })
                    }
                    className={`w-full py-2 rounded-lg text-white ${session.recordedVideoUrl
                      ? "bg-purple-600 hover:bg-purple-700"
                      : "bg-gray-400 cursor-not-allowed"
                      }`}
                  >
                    View Recording
                  </button>
                  {/*View Details Button */}

                  <button
                    onClick={() => handleViewDetails(session)}
                    className="w-full py-2 rounded-lg border border-purple-600 text-purple-600 hover:bg-purple-50"
                  >
                    View Details
                  </button>
                </div>

              </div>
            ))}

          </div>
        )}

      {/* ================= CONTENT SCREEN ================= */}

      {selectedSession && (
        <div className="bg-white rounded-2xl shadow border p-6">

          {/* HEADER */}
          <div className="flex justify-between items-center mb-6">

            <div>
              <h2 className="text-2xl font-bold text-purple-700">
                {selectedSession.topic}
              </h2>

              <p className="text-gray-500 mt-1">
                {selectedSession.subject} • {selectedSession.chapter}
              </p>
            </div>

            <button

              onClick={() => {
                setSelectedSession(null);
                setTopicContents([]);
                setSelectedType(null);
              }}

              className="border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50"
            >
              Back
            </button>

          </div>

          {/* LOADING */}
          {contentLoading ? (
            <div className="text-center py-10">
              Loading contents...
            </div>
          ) : topicContents.length === 0 ? (
            <div className="text-center py-10 text-gray-400">
              No content available
            </div>
          ) : (
            <>
              {/* ================= CONTENT DROPDOWN SECTION ================= */}

              <div className="space-y-5">

                {/* ================= VIDEOS ================= */}
                {(groupedContents["mp4"] || []).length > 0 && (

                  <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

                    <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-purple-50">

                      <div>

                        <h2 className="text-xl font-bold text-purple-700">
                          🎥 Class Recording
                        </h2>

                        <p className="text-sm text-gray-500">
                          {(groupedContents["mp4"] || []).length} Videos Available
                        </p>

                      </div>

                      <span className="text-purple-700 text-xl">
                        ▼
                      </span>

                    </summary>

                    <div className="p-4 space-y-3">

                      {(groupedContents["mp4"] || []).map((content, index) => (

                        <div
                          key={content.contentid}
                          // onClick={() =>
                          //   navigate("/player", {
                          //     state: {
                          //       url: content.playUrl,
                          //       //url: "https://devstreaming-cdn.apple.com/videos/streaming/examples/adv_dv_atmos/main.m3u8",
                          //     },
                          //   })
                          //}

                          onClick={() =>
                            navigate("/player", {
                              state: {
                                url: content.playUrl,

                                returnState: {
                                  selectedSession,
                                  topicContents,
                                  filters,
                                  sessions,
                                },
                              },
                            })
                          }



                          className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-purple-50 transition"
                        >

                          <div className="flex items-center gap-3">

                            <span className="text-purple-700 font-semibold">
                              🎥
                            </span>

                            <span className="font-medium text-gray-700">
                              {content.displayname || `Video ${index + 1}`}
                            </span>

                          </div>

                          <span className="text-sm text-purple-600 font-semibold">
                            Play
                          </span>

                        </div>

                      ))}

                    </div>

                  </details>

                )}

                {/* ================= PDF NOTES ================= */}
                {(groupedContents["pdf"] || []).length > 0 && (

                  <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

                    <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-blue-50">

                      <div>

                        <h2 className="text-xl font-bold text-blue-700">
                          📄 Class Notes
                        </h2>

                        <p className="text-sm text-gray-500">
                          {(groupedContents["pdf"] || []).length} Notes Available
                        </p>

                      </div>

                      <span className="text-blue-700 text-xl">
                        ▼
                      </span>

                    </summary>

                    <div className="p-4 space-y-3">

                      {(groupedContents["pdf"] || []).map((content, index) => (

                        <div
                          key={content.contentid}
                          onClick={() =>
                            window.open(content.playUrl, "_blank")
                          }
                          className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-blue-50 transition"
                        >

                          <div className="flex items-center gap-3">

                            <span className="text-blue-700 font-semibold">
                              📄
                            </span>

                            <span className="font-medium text-gray-700">
                              {content.displayname || `Notes ${index + 1}`}
                            </span>

                          </div>

                          <span className="text-sm text-blue-600 font-semibold">
                            Open
                          </span>

                        </div>

                      ))}

                    </div>

                  </details>

                )}

                {/* ================= HTML CONTENT ================= */}
                {(groupedContents["html"] || []).length > 0 && (

                  <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

                    <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-green-50">

                      <div>

                        <h2 className="text-xl font-bold text-green-700">
                          📝 Curated Content
                        </h2>

                        <p className="text-sm text-gray-500">
                          {(groupedContents["html"] || []).length} Contents Available
                        </p>

                      </div>

                      <span className="text-green-700 text-xl">
                        ▼
                      </span>

                    </summary>

                    <div className="p-4 space-y-3">

                      {(groupedContents["html"] || []).map((content, index) => (

                        <div
                          key={content.contentid}
                          onClick={() =>
                            window.open(content.playUrl, "_blank")
                          }
                          // onClick={async () => {

                          //   try {

                          //     // XML FILE
                          //     if (
                          //       content.playUrl
                          //         ?.toLowerCase()
                          //         ?.endsWith(".xml")
                          //     ) {

                          //       const parsedContents =
                          //         await readSmartClassXML(
                          //           content.playUrl
                          //         );

                          //       console.log(
                          //         "PARSED CONTENTS:",
                          //         parsedContents
                          //       );

                          //       navigate("/player", {
                          //         state: {
                          //           contents: parsedContents,
                          //         },
                          //       });

                          //       return;
                          //     }

                          //     // NORMAL CONTENT
                          //     navigate("/player", {
                          //       state: {
                          //         contents: [
                          //           {
                          //             id: 1,
                          //             title:
                          //               content.displayname || "Content",
                          //             type: content.mediatype,
                          //             url: content.playUrl,
                          //           },
                          //         ],
                          //       },
                          //     });

                          //   } catch (err) {

                          //     console.error(err);

                          //   }

                          // }}
                          className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-green-50 transition"
                        >

                          <div className="flex items-center gap-3">

                            <span className="text-green-700 font-semibold">
                              📝
                            </span>

                            <span className="font-medium text-gray-700">
                              {content.displayname || `Content ${index + 1}`}
                            </span>

                          </div>

                          <span className="text-sm text-green-600 font-semibold">
                            Open
                          </span>

                        </div>

                      ))}

                    </div>

                  </details>

                )}


                {/* ================= TEST / MCQ ================= */}
                {(groupedContents["mcq"] || []).length > 0 && (

                  <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

                    <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-orange-50">

                      <div>

                        <h2 className="text-xl font-bold text-orange-600">
                          ❓ Tests
                        </h2>

                        <p className="text-sm text-gray-500">
                          {(groupedContents["mcq"] || []).length} Tests Available
                        </p>

                      </div>

                      <span className="text-orange-600 text-xl">
                        ▼
                      </span>

                    </summary>

                    <div className="p-4 space-y-3">

                      {(groupedContents["mcq"] || []).map((content, index) => (

                        <div
                          key={content.contentid}
                          onClick={async () => {

                            try {

                              console.log("CONTENT:", content);

                              // TEMP STATIC TEST ID
                              const testId =
                                content.contentid

                              setContentLoading(true);

                              const testResponse =
                                await getTestByTestId(testId);

                              console.log(
                                "TEST RESPONSE:",
                                testResponse
                              );

                              // navigate("/player", {
                              //   state: {
                              //     type: "mcq",
                              //     testData: testResponse,
                              //   },
                              // });

                              navigate("/player", {
                                state: {
                                  type: "mcq",
                                  testData: testResponse,

                                  returnState: {
                                    selectedSession,
                                    topicContents,
                                    filters,
                                    sessions,
                                  },
                                },
                              });


                            } catch (err) {

                              console.error(err);

                            } finally {

                              setContentLoading(false);

                            }

                          }}
                          className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-orange-50 transition"
                        >

                          <div className="flex items-center gap-3">

                            <span className="text-orange-600 font-semibold">
                              ❓
                            </span>

                            <span className="font-medium text-gray-700">
                              {content.displayname || `Test ${index + 1}`}
                            </span>

                          </div>

                          <span className="text-sm text-orange-600 font-semibold">
                            Start
                          </span>

                        </div>

                      ))}

                    </div>

                  </details>

                )}

              </div>
            </>

          )}
        </div>
      )
      }
    </div >
  );
}












